import styled from "styled-components";
import { pxToRem } from "styles/utils";
import { Input as SharedInput } from "../../IOSCompatibleInput/IOSCompatibleInput.style";
import {
  ModalBodyBase,
  ModalCloseButtonBase,
  ModalDividerBase,
  ModalFooterBase,
  ModalHeaderBase,
  ModalOverlayBase,
  ModalSurfaceBase,
} from "../ModalPrimitives";

export const ModalOverlay = styled(ModalOverlayBase)``;

export const ModalContent = styled(ModalSurfaceBase)`
  display: flex;
  flex-direction: column;
  width: min(60vw, ${pxToRem(760)});
  min-width: ${pxToRem(550)};

  @media (max-width: 760px) {
    width: 100%;
    min-width: 0;
  }
`;

export const ModalHeader = styled(ModalHeaderBase)``;

export const Divider = styled(ModalDividerBase)``;

export const CloseButton = styled(ModalCloseButtonBase)``;

export const ModalBody = styled(ModalBodyBase)`
  padding-bottom: 0;
`;

export const ModalFooter = styled(ModalFooterBase)`
  justify-content: center;
  padding-top: 0;

  form {
    width: 100%;
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xl)};

  textarea {
    max-height: calc(60vh - ${pxToRem(350)});
  }
`;

export const Input = styled(SharedInput)``;

export const ErrorMessage = styled.div`
  margin-top: ${({ theme }) => pxToRem(-theme.spacing.xs)};
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  line-height: 1.35;
`;

export const DragAndDropLinkField = styled.div`
  width: 100%;
`;

export const SwitchFieldRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => pxToRem(theme.spacing.xxs)};
`;

export const SwitchHelpButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(18)};
  height: ${pxToRem(18)};
  padding: 0;
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkBorder};
  border-radius: 50%;
  background: transparent;
  color: ${({ theme }) => theme.colors.inkSoft};
  font: inherit;
  font-size: ${pxToRem(12)};
  font-weight: 600;
  line-height: 1;
  cursor: help;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.brand};
    background: ${({ theme }) => theme.colors.inkSurface};
  }

  &:focus-visible {
    color: ${({ theme }) => theme.colors.brand};
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(1)};
  }
`;